import { REACTION_TYPES, ReactionType } from '../api/types';

/**
 * This method and all implementation needs to be removed once the backoffice no longer returned 'like' as a ReactionType.
 * TODO: CMS-1169 - Once the backend API's are updated to return a ReactionState from the PUT and DELETE, remove the method and all it's implementations.
 * */
export const filterReactionTypes = (reactions: ReactionType[]) => {
    return reactions?.filter((reaction) => REACTION_TYPES.includes(reaction)) ?? [];
};
